const formatMoney = (amount, currency = 'USD') => {
  const options = { style: 'currency', currency };
  const formatter = new Intl.NumberFormat('en-US', options);
  return formatter.format(+amount);
};

export default formatMoney;
